import { ROUTES } from "@app/config/constants";
import { useAuthStore } from "@lib/auth/authStore";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppLayout } from "@/app/layouts/AppLayout";

export const Route = createFileRoute("/_app")({
  loader: async ({ location }) => {
    const { isLoggedIn } = useAuthStore.getState();
    if (!isLoggedIn) {
      throw redirect({ to: ROUTES.APP.AUTH_LOGIN, search: { redirect: location.href } });
    }
  },
  component: AppLayout,
});
